import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PublicLayout from "web/components/PublicLayout";
import Pagination from 'web/components/Pagination';
import Featured from 'web/pages/public/landing-page/Featured';
import styles from './searchPost.module.scss';
import AlertModal from "web/components/AlertModal";
import { guestUserInventroy } from "redux/actions/postLoad";
import LandingFooter from "../LandingFooter";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const SearchInventory = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const [searchResponse, setSearchResponse] = useState({ payload: [], title: '', totalRecods: '' });
  const [sortState, setSortState] = useState("DESC");
  const [postNameSearch, setPostNameSearch] = useState("");
  const token = localStorage.getItem("token");
  const [advanceSearch, setAdvanceSearch] = useState();
  let selectedPageNo = 1
  const [currentPage, setCurrentPage] = useState(selectedPageNo);


  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMyAPI(currentPage, sortState, postNameSearch);
  }, []);

  useEffect(() => {
    let token = localStorage.getItem('token')
    let isAdminOrUserAccount = localStorage.getItem('accountType')
    if (isAdminOrUserAccount && token) {
      if (isAdminOrUserAccount === 'Admin') history.push('/admin')
      else history.push('/dashboard')
    } else {
      dispatch(logoutAdmin())
      dispatch(logoutClearRedux())
      localStorage.clear()
      sessionStorage.clear()
    }
  }, [])


  const fetchMyAPI = async (selectedPage, sortState, postNameSearch, advanceSearchObj) => {
    let data = {
      size: 20,
      number: selectedPage - 1 || 0,
      sort: sortState || "DESC",
      searchBy: postNameSearch || '',
      sortBy: null,
      miles: '',
      isFilter: false,
      filters: null,
    }

    if (advanceSearchObj) {
      data = {
        ...data,
        miles: advanceSearchObj ? advanceSearchObj?.mile : '',
        isFilter: true,
        filters: {
          city: advanceSearchObj ? advanceSearchObj?.city : '',
          state: advanceSearchObj ? advanceSearchObj?.state : '',
          palletSize: advanceSearchObj ? advanceSearchObj?.size : '',
          grade: advanceSearchObj ? advanceSearchObj?.grade : ''
        },
      }
    }

    let response = await dispatch(guestUserInventroy(data, token));

    if (response.success) {
      if (response.data?.inventorySearch?.length !== 0) {
        setSearchResponse({ payload: response.data?.inventorySearch, title: '', totalRecods: response.data.totalElements })
      } else {
        setSearchResponse({ payload: [], title: '', totalRecods: '' })
      }
    } else if (response.statusCode === 409) {
      setSearchResponse({ payload: [], title: '', totalRecods: '' })
    } else {
      setModalContent(response.message);
      setModalLink("");
      toggleModal();
    }
  };

  return (
    <>
      <Helmet title="PalletTrader | Pallet Inventory">
        <meta name="description"
          content="Find pallets near me with PalletTrader’s online inventory. Easily search by location, type, and quantity to buy pallets for your business needs." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/search-inventory" />
      </Helmet>
      <PublicLayout transparentHeader={true} tabType="PostInventory">
        <div className={styles.homeWrapper}>
          <div className={styles.wrapper}>
            <div className={styles.section}>
              <Featured
                totalRecord={searchResponse.totalRecods}
                response={searchResponse.payload}
                title=""
                currentPage={currentPage}
                onChangeHandler={(val) => {
                  setSortState(val)
                  setAdvanceSearch()
                  setCurrentPage(1)
                  //setSearchResponse({ payload: [], title: '', totalRecods: '' })
                  fetchMyAPI(1, val, postNameSearch);
                }}
                searchCallBack={(val) => {
                  setPostNameSearch(val)
                  setCurrentPage(1);
                  setSearchResponse({ payload: [], title: '', totalRecods: '' })
                  fetchMyAPI(1, null, val, advanceSearch);
                }}
                advanceSearchCallBack={(val) => {
                  setAdvanceSearch(val)
                  setCurrentPage(1);
                  //setSearchResponse({ payload: [], title: '', totalRecods: '' })
                  fetchMyAPI(1, sortState, '', val);
                }}
              />
            </div>
            {searchResponse.payload.length !== 0 &&
              searchResponse.totalRecods && (
                <Pagination
                  currentPage={currentPage}
                  totalPage={searchResponse.totalRecods}
                  itemsCountPerPage={20}
                  onPageChange={(value) => {
                    setCurrentPage(value);
                    fetchMyAPI(value, sortState, postNameSearch, advanceSearch);
                  }}
                />
              )}
          </div>
        </div>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title=''
          content={modalContent}
          link={modalLink}
        />
        <LandingFooter isBackgroundWhite={true} />
      </PublicLayout>

    </>
  );
};

export default SearchInventory;
